/**
 * 模板导出：商品名称「动态值 → 标题 → 语种」比对与翻译决策（不修改原标题）。
 */

/** 模板 rightValue / AI 文案 language → 可比对短码；原标题返回 null（不翻译）。 */
export function normalizeExportTitleLanguage(raw) {
  const value = String(raw || '').trim();
  if (!value) return null;
  const lower = value.toLowerCase();
  if (value === '原标题' || value.includes('原标题') || lower === 'original') {
    return null;
  }
  if (lower.startsWith('zh') || value.includes('中文') || lower === 'cn' || lower === 'chinese') {
    return 'zh';
  }
  if (lower.startsWith('en') || value.includes('英语') || value.includes('英文') || lower === 'english') {
    return 'en';
  }
  if (lower.startsWith('de') || value.includes('德语') || value.includes('德文') || lower === 'german') {
    return 'de';
  }
  if (lower.startsWith('fr') || value.includes('法语') || value.includes('法文') || lower === 'french') {
    return 'fr';
  }
  if (lower.startsWith('it') || value.includes('意大利') || lower === 'italian') {
    return 'it';
  }
  if (lower.startsWith('es') || value.includes('西班牙') || lower === 'spanish') {
    return 'es';
  }
  if (lower.startsWith('ja') || value.includes('日语') || value.includes('日文') || lower === 'japanese') {
    return 'ja';
  }
  if (lower.startsWith('ko') || value.includes('韩语') || value.includes('韩文') || lower === 'korean') {
    return 'ko';
  }
  return lower.replace(/_/g, '-');
}

/** 从表头如「默认商品名称[en]」解析语种短码。 */
export function extractLanguageFromHeaderName(headerName) {
  const match = String(headerName || '').match(/\[([a-z]{2}(?:-[a-z]{2})?)\]/i);
  if (!match) return null;
  return normalizeExportTitleLanguage(match[1]);
}

/**
 * 粗判正文是否像目标语种。元数据标错时（如 language=en 但正文是中文）仍可强制翻译。
 */
export function textLooksLikeLanguage(text, langCode) {
  const s = String(text || '').trim();
  if (!s || !langCode) return true;
  const cjk = (s.match(/[\u3400-\u9FFF]/g) || []).length;
  const latin = (s.match(/[A-Za-zÀ-ÿ]/g) || []).length;
  if (langCode === 'zh' || langCode === 'ja' || langCode === 'ko') {
    return cjk >= 2;
  }
  // 英/德/法等：正文若含较多汉字，则不像目标语
  if (cjk >= 4) return false;
  return latin >= 3 || cjk === 0;
}

/**
 * 是否需要为导出翻译标题。
 * - 原标题：不译
 * - 源语种与模板语种一致，且正文也像目标语：不译
 * - 源语种未知 / 不同 / 正文明显不像目标语：需要译
 */
export function shouldTranslateExportTitle(sourceLanguage, templateLanguageRightValue, titleText = '') {
  const target = normalizeExportTitleLanguage(templateLanguageRightValue);
  if (!target) return false;
  const source = normalizeExportTitleLanguage(sourceLanguage);
  if (source && source === target) {
    if (titleText && !textLooksLikeLanguage(titleText, target)) {
      return true;
    }
    return false;
  }
  if (titleText && !textLooksLikeLanguage(titleText, target)) {
    return true;
  }
  return true;
}

export function resolveExportTitleTargetLanguage(templateLanguageRightValue, headerName = '') {
  return normalizeExportTitleLanguage(templateLanguageRightValue)
    || extractLanguageFromHeaderName(headerName);
}
